<template>
    <v-container>
        <v-row justify="center" class="mb-10">
            <v-col cols="12" sm="10" md="7" lg="5">
                <TopBar backPage="orders_history"/>
                <v-divider class=""></v-divider>
                <div class="mt-3" >
                    <v-card>
                        <OrderProcessLine :order="$store.state.order" class="ma-2"/>
                        <v-card-text v-if="$store.state.order.status == '0' && (!detail.status || detail.status != 1)">
                            <v-select
                                :items="$store.state.info.payment_methods"
                                item-value="id"
                                v-model="payment_method"
                                density="compact"
                                variant="outlined"
                                label="شیوه پرداخت"
                                />
                            <v-textarea
                                density="compact"
                                variant="outlined"
                                v-model="order_description"
                                rows="2"
                                label="توضیحات"
                                />
                           <span class="text-red" v-html="$store.state.info.payment_methods.find(e=>e.id == payment_method).description.replaceAll('\n','<br/>')">
                           </span>
                        </v-card-text>
                        <v-card-actions>
                            <strong>
                                مبلغ سفارش
                            </strong>
                            <v-spacer></v-spacer>
                            <strong>{{ new Intl.NumberFormat('fa-IR').format($store.state.order.total_price) }}</strong>
                            {{ $t('rial') }}
                        </v-card-actions>
                        <v-card-text v-if="!!detail.status && detail.status == 1" class="text-center text-success">
                             <v-icon>mdi-check</v-icon>
                            پرداخت سفارش به صورت آنلاین انجام شده است.
                        </v-card-text>
                        <v-card-text v-if="$store.state.order.status == '0' && (!detail.status || detail.status != 1)">
                             <v-btn
                             v-if="payment_method == 4"
                                block
                                color="red"
                                variant="flat"
                                :loading="$store.state.bookingLoading"
                                @click="$store.dispatch('PayOrder',{
                                    order_id:$store.state.order.id,
                                    payment_method:payment_method,
                                    order_description:order_description,
                                })"
                                >
                                پرداخت آنلاین
                            </v-btn>
                             <v-btn
                                v-else
                                block
                                color="primary"
                                variant="flat"                                
                                :loading="$store.state.bookingLoading"
                                @click="$store.dispatch('UpdateOrder',{
                                    order_id:$store.state.order.id,
                                    payment_method:payment_method,
                                    order_description:order_description,
                                })"
                                >
                                ذخیره تغییرات
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </div>
                <v-card class="mt-3 pt-3">
                    <v-card-text class="pa-1">
                        <div class="cart-detail">
                            <h4 class="mr-3">جزئیات سفارش:</h4>
                            <v-card class="border-b-sm border-solid my-1 py-3 px-2" color="white" variant="flat"  v-for="(cartItem,index) in $store.state.order.cart" :key="`cartItem`+index">
                                <div class="d-flex flex-column justify-space-between">
                                    <div class="d-flex justify-space-between">
                                        <strong style="flex-grow: 2;">
                                            {{ cartItem.title }}
                                            <span v-if="!!cartItem.variable && cartItem.variable.name"
                                                class="text-caption text-grey-darken-3">
                                                ({{ cartItem.variable.name }})
                                            </span>
                                        </strong>
                                        <strong style="flex-grow: 0;" class="pl-5">
                                            {{cartItem.total}} عدد
                                        </strong>
                                    </div>
                                    <div v-if="!!cartItem.addons && cartItem.addons.length > 0" class="d-flex flex-column mt-1">
                                        <div v-for="(addon,index) in cartItem.addons" :key="`addon`+index" class="text-grey my-1">
                                            <v-icon>mdi-plus</v-icon>
                                            {{ addon.title }}
                                            ({{ addon.total }})
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TopBar from '@/components/top_bar.vue';
    import OrderProcessLine from '@/components/order-process-line.vue';

    export default {
        name: "OrderDetailPage",
        components: {
            TopBar,
            OrderProcessLine,
        },
        data() {
            return {
                payment_method:0,
                order_description:"",
                detail:{},
            };
        },
        methods:{
            
        },
        created(){
            this.payment_method = Number.parseInt(this.$store.state.order.payment_method)
            this.order_description = this.$store.state.order.order_description
            this.detail = JSON.parse(this.$store.state.order.detail)
        }
    };
</script>

